class GiftCardForm extends window.HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.addToCartButton = this.querySelector('.gift-card-add-to-cart');
    this.giftToggleButton = this.querySelector('.gift-toggle');
    this.giftOptions = this.querySelector('#giftOptions');
    this.isGiftCheckbox = this.querySelector('#isGift');
    this.recipientEmailInput = this.querySelector('#recipientEmail');
    this.recipientNameInput = this.querySelector('#recipientName');
    this.messageInput = this.querySelector('#message');
    this.sendOnInput = this.querySelector('#sendOn');
    this.recipientEmailError = this.querySelector('.email-errors');

    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', () => this.addToCart());
    }

    if (this.giftToggleButton && this.isGiftCheckbox && this.giftOptions) {
      this.giftToggleButton.addEventListener('click', () => {
        this.isGiftCheckbox.checked = !this.isGiftCheckbox.checked;
        this.giftOptions.style.display = this.isGiftCheckbox.checked ? 'block' : 'none';

        if (!this.isGiftCheckbox.checked) {
          this.resetGiftFields();
        }
      });
    }
  }

  resetGiftFields() {
    this.recipientEmailInput.value = '';
    this.recipientNameInput.value = '';
    this.messageInput.value = '';
    this.sendOnInput.value = '';
    this.recipientEmailError.classList.add('hidden');
  }

  addToCart() {
    const cartForm = this.closest('cart-form');
    if (!cartForm) {
      console.error('No cart form found.');
      return;
    }

    const dataForm = JSON.parse(cartForm.getAttribute('data-form'));
    const itemId = Object.keys(dataForm.items)[0];
    const itemQuantity = dataForm.items[itemId].quantity;

    const payload = {
      id: dataForm.items[itemId].id,
      quantity: itemQuantity,
      properties: {}
    };

    const isGift = this.isGiftCheckbox.checked;
    if (isGift) {
      const recipientEmail = this.recipientEmailInput.value;
      const recipientName = this.recipientNameInput.value;
      const message = this.messageInput.value;
      const sendOn = this.sendOnInput.value;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!recipientEmail) {
        this.recipientEmailError.innerHTML = "Email can't be blank.";
        this.recipientEmailError.classList.remove('hidden');
        return;
      }

      if (!emailPattern.test(recipientEmail)) {
        this.recipientEmailError.innerHTML = "Enter a valid email.";
        this.recipientEmailError.classList.remove('hidden');
        return;
      }

      this.recipientEmailError.classList.add('hidden');

      payload.properties['__shopify_send_gift_card_to_recipient'] = 'on';
      if (recipientEmail) payload.properties['Recipient email'] = recipientEmail;
      if (recipientName) payload.properties['Recipient name'] = recipientName;
      if (message) payload.properties['Message'] = message;
      if (sendOn){
        payload.properties['Send on'] = sendOn;
        payload.properties['__shopify_offset'] = new Date().getTimezoneOffset().toString();
      }
    }

    console.log('Payload before sending:', payload);

    cartForm?.formDataAPI?.updateItems(payload);
    cartForm?.reqCart();
  }
}

window.customElements.define('gift-card-form', GiftCardForm);